// extracted by mini-css-extract-plugin
export default {"JoursEssai":"JoursEssai_JoursEssai__dQmnu","Textes":"JoursEssai_Textes__pdeat","Description":"JoursEssai_Description__hdFlB"};